import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
} from '../../components'
import Styles from './About.css'

@CSSModules(Styles, {allowMultiple:true})
export default class AboutGef extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'Gender Equality'
    const url = config.domain + config.routes.aboutGef
    const equileapLogo = require( '../../../static/images/about/Equileap logo.png' )
    const gefIcon = require( '../../../static/images/about/gef-icon.jpg' )
    const clipboardClockGraphic = require( '../../../static/images/about/clipboard-clock-graphic.png' )

    //
    return <div>
      {container.helmet(title, '', url)}
      <ContainerDivs>

        
        <header styleName='header-subpage'>
          <h1 styleName='header-subpage__headline'>{title}</h1>
          <div styleName='header-subpage__image-banner--gef' />
        </header>


        <section styleName='lede-content'>
          <br/>
          <br/>

          <p styleName='lede-content__copy'>
            <b>Gender Equality in the workplace can be achieved when companies commit and are held accountable to promoting gender balance in leadership, equal pay, and fostering work-life balance for all their employees – regardless of their gender.</b>
          </p>

          <p styleName='lede-content__copy'>
            Women make up 47% of the workforce, yet <Link xstrong title='The share of Fortune 500 companies run by women CEOs stays flat at 10.4% as pace of change stalls' to='https://fortune.com/2024/06/04/fortune-500-companies-women-ceos-2024/'>only 10.4%</Link> hold CEO roles. For every 100 men promoted to manager, only 89 white women and <Link xstrong title='The State of Women in the Workplace 2025: Progress, Setbacks, and What Comes Next' to='https://www.hrfuture.net/workplace-culture/diversity-equity-inclusion/the-state-of-women-in-the-workplace-2025-progress-setbacks-and-what-comes-next/'>54 Black women</Link> are promoted. Women are paid <Link xstrong title='Gender pay gap in U.S. has narrowed slightly over 2 decades' to='https://www.pewresearch.org/short-reads/2025/03/04/gender-pay-gap-in-us-has-narrowed-slightly-over-2-decades/'>85 cents</Link> on the dollar of their male colleagues, with <Link xstrong title='The State of Women in the Workplace 2025: Progress, Setbacks, and What Comes Next' to='https://www.hrfuture.net/workplace-culture/diversity-equity-inclusion/the-state-of-women-in-the-workplace-2025-progress-setbacks-and-what-comes-next/'>even larger pay gaps</Link> for women of color. <Link xstrong title='US 2025 Women Professionals in the Modern Workplace' to='https://www.hibob.com/research/us-2025-women-professionals-in-the-modern-workplace/'>Only 29%</Link> of women agree their organization provides flexible arrangements that support work-life balance. Clearly, we have a long way to go to reach gender equality in the workplace.
          </p>

          <p styleName='lede-content__copy'>
            <b>Social Justice Funds</b> empowers investors to harness their personal economic power to support gender equality in the workplace while maximizing returns. To do so, we integrated our existing Gender Equality Funds dataset into this new tool.
          </p>
        </section>


        <section styleName='section-panel'>
          <h2 styleName='section-panel__headline'>
            Gender Equality Funds
          </h2>
          <div styleName='section-panel__content'>
            <div styleName='section-panel__copy-wrap'>
              <p styleName='section-panel__copy'>
                <Link xstrong to='https://genderequalityfunds.org/' title=''>Gender Equality Funds</Link> is a search platform that enables investors to find out if their money, in the form of individual mutual fund investments or an employer-provided 401(k), is invested in companies leading on gender diversity and equality. It helps investors find socially responsible options that prioritize companies with an equal gender balance and strong policies promoting gender equality.  
              </p>
            </div>
            <div styleName='section-panel__image-wrap'>
              <img src={gefIcon} alt='Gender Equality Funds'  styleName='section-panel__gef-icon'/>
            </div>
          </div>
        </section>


        <section styleName='section-panel'>
          <h2 styleName='section-panel__headline'>
            Equileap
          </h2>
          <div styleName='section-panel__content'>
            <div styleName='section-panel__copy-wrap'>
              <p styleName='section-panel__copy'>
                To build Gender Equality Funds, <i>As You Sow</i> partnered with <Link xstrong to='http://equileap.org/' title=''>Equileap</Link>, a women-led social venture working to accelerate progress towards gender equality as a vital lever in reducing poverty and inequality. This tool is powered by the <Link xstrong to='https://equileap.com/equileap-reports/' title=''>Equileap Gender Equality Scorecard</Link>, inspired by the UN’s Women Empowerment Principles, and scores companies based on 19 criteria, including gender balance across the workforce, the gender pay gap, paid parental leave, and anti-sexual harassment policies. 
              </p>
            </div>
            <div styleName='section-panel__image-wrap'>
              <img src={equileapLogo} alt='Equileap'  styleName='section-panel__equileap-logo'/>
            </div>
          </div>
        </section>


        <section styleName='section-panel'>
          <div styleName='section-panel__image-wrap'>
            <img src={clipboardClockGraphic} alt='Visit our Action Toolkit'  styleName='section-panel__graphic-image'/>
          </div>
          <h2 styleName='section-panel__headline section-panel__headline--center section-panel__headline--purple'>
            Visit our Action Toolkit
          </h2>
          <div styleName='section-panel__narrow-content'>
            <ul styleName='section-panel__list section-panel__list--flush'>
              <li>
                Learn how to make a change and align your investments with gender equality
              </li>
              <li>
                Ask your financial advisor about Social Justice investing
              </li>
              <li>
                Push your employer to provide socially just investment options
              </li>
            </ul>

            <Link roundbutton to={config.routes.toolkit} title='Take action'>
              Take action
            </Link>
          </div>
        </section>


      </ContainerDivs>
    </div>
  }
}
